export class department {
  departmentUno?: number;
  departmentEn?: string;
  departmentAr?: string;
  departmentCode?: string;
  departmentAdminUno?: number;
  divisionUno?: number;
  kPILastAutoId?: number;
  departmentCoordinatorUno?: number;
  departmentApproverUno?: number;
  isActive?: string;
  divisionName?: string;
  departmentAdminName?: string;
  coordinatorName?: string;
  approverName?: string;
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
}
export class targetMaster {
  targetUno?: number;
  targetName?: string;  
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
}

export class fileManager {
  fileUno?: number = 0;
  permissionType?: number = 0;
  parentId?: number;
  isFile?: boolean;
  fileName?: string;
  filePath?: string;
  userUno?: string;
  condition?: number;
  enteredBy: string;
  enteredDate: string;
  selectedUser: any;
}
export class division {
  divisionUno?: number;
  divisionNameEn?: string;
  divisionNameAr?: string;
  divisionHeadUno?: number;
  divisionAdminUno?: number;
  divisionName?: string;
  divisionAdminName?: string;
  coordinatorName?: string;
  approverName?: string;
  divisionCode?: string;
  kPILastAutoId?: number;
  divisionCoordinatorUno?: number;
  divisionApproverUno?: number;
  isActive?: number;
  user?: number;
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
}

export class interaction {
  interactionUno?: number;
  interactionNameEn?: string;
  interactionNameAr?: string;  
  isActive?: number;
  user?: number;
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
}

export class tenant {
  tenantUno?: number;
  tenantNameEn?: string;
  tenantNameAr?: string;
  isActive?: number;
  user?: number;
  currentYear?: number;
  currentHalf?: number;
  currentQuarter?: number;
  currentMonth?: number;
  wellPerformKPIRange?: number;
  fromEmail?: string;
  slaName?: string;
  siteHeading?: string;
  isDigitalDewa?: number;
  isDynamicEntry?: number;
  isEnableNotification?: number;

  //filter
  userUno?: string;
  enteredBy?: string;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
}
export class user {
  displayText?: string;
  userImage?: string;
  userUno?: string;
  tenantUno?: number;
  divisionUno?: number;

  //filter  
  languageUno?: number;
  itemUno?: number;
  condition?: number;
}

export class usermaster {

  ntUsername?: string;
  displayNameEn?: string;
  displayNameAr?: string;
  firstname?: string;
  lastname?: string;
  emailId?: string;
  designationEn?: string;
  divisionUno?: number;
  userTypeUno?: number;
  usergroupUno?: number;
  enteredBy?: string;
  userName?: string;
  designationAr?: string;
  userTypeNameEn?: string;
  userTypeNameAr?: string;
  divisionNameEn?: string;
  divisionNameAr?: string;
  usergroupEn?: string;
  welcomeEmailSEND?: string='';
  userPhoto?: string;
  ntLogin?: string='';
  //filter
  tenantUno?: string;
  tenantNameEn?: string;
  userUno?: string;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
  lastLogin: string;
  userenable: string;
  prNumber: string;
  externalUser: number;
  password: string;
  confirmPassword: string;
  multiTenant?: string;
  createdBy?: string;
  createdOn?: string;
  modifiedBy?: string;
  modifiedOn?: string;
}
export class userpermission {
  enteredBy: string;
  userPermissionUno?: number;  
  isDefault?: number;
  userRoleUno?: number;
  userRole?: string;
  userTypeUno?: number;
  userType?: string;
  tenantUno?: number;
  tenant?: string;
  divisionUno?: number;
  divisionName?: string;
  userUno?: string;
  itemUno?: number;
  condition?: number;
 
}
export class performancemaster {
  id?: number;
  titleNameEn?: string;
   titleNameAr?: string;
  continentUno?: number;
  continentNameEn?: string;
  continentNameAr?: string;
  countryUno?: number;
  countryNameEn?: string;
  countryNameEnAr?: string;
  regionUno?: number;
  regionNameEn?: string;
  regionNameAr?: string;
  sourceTypeUno?: number;
  sourceTypeNameEn?: string;
  sourceTypeNameAr?: string;
  sourceUno?: number;
  sourceNameEn?: string;
  sourceNameAr?: string;
  sourceDescription?: string;
  utilityTypeUno?: number;
  utilityTypeEn?: string;
  utilityTypeAr?: string;
  peerTypeUno?: number;
  peerTypeEn?: string;
  peerTypeAr?: string;
  technologyUsed?: string;
  businessModel?: string;

  strategicObjectiveUno?: number;
  strategicObjectiveNameEn?: string;
  strategicPriorityNameEn?: number;
  strategicPriorityUno?: string;
  isActive?: number;
  tableName?: string;
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
}
export class benchmarkprogressmaster {
  id?: number;
  bmProgressName?: string;
  bmProgressValue?: number;
  bmProgressTypeUno?: number;
  bmProgressType?: number;
  isActive?: number;
  tableName?: string;
  //filter
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  actionType: string;
  assignUsers?: string;
  startDate?: any;
  endDate?: any;
}
export class geographicArea {
  areaUno?: number;
  areaNameEn?: string;
  areaNameAr?: string;
  isActive?: number;

  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  flag: string;
}
export class projectImportance {
  projectImportanceUno?: number;
  projectImportanceEn?: string;
  projectImportanceAr?: string;
  isActive?: number;
  userUno?: string;
  tenantUno?: number;
  languageUno?: number;
  itemUno?: number;
  condition?: number;
  flag: string;
}
